import { Component, inject, viewChild, ChangeDetectionStrategy } from '@angular/core';

import { TagComponent } from '../../../../../common/tag/tag.component';
import { Select2SelectedItemDirective } from '../../../default-templates/selected-item/selected-item.directive';

@Component({
  selector: 'rt-select-selected-item-multi',
  imports: [Select2SelectedItemDirective, TagComponent, Select2SelectedItemDirective],
  template: `
    <ng-container *rtSelectSelectedItem="null; let dir; let item = item">
      <rt-tag [name]="item.label" />
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: Select2SelectedItemDirective,
      useFactory: () => inject(MultiSelectItemComponent).directive(),
    },
  ],
})
export class MultiSelectItemComponent {
  public directive = viewChild.required(Select2SelectedItemDirective);
}
